import React from 'react';
import styled from 'styled-components';
import { ICONS } from '../constants';

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  width: ${({ $size }) => $size || 18}px;
  height: ${({ $size }) => $size || 18}px;
  color: ${({ $color }) => $color || 'currentColor'};
  flex-shrink: 0;

  & > svg {
    width: 100%;
    height: 100%;
  }
`;

const Icon = ({ name, size, color, className }) => {
  const svg = ICONS[name];
  if (!svg) return null;

  return (
    <IconWrap
      $size={size}
      $color={color}
      className={className}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

export default Icon;
